<template>
    <div class="admin-content">
        <div class="left-wrapper">
            <el-menu :default-active="schoolTab" class="left-nav">
                <el-menu-item index="schoolEducationIndex">
                    <router-link class="nav-item" to="/school/education/index">专业管理</router-link>
                </el-menu-item>
                <el-menu-item index="schoolEducationTeacher">
                    <router-link class="nav-item" to="/school/education/teacher">教师管理</router-link>
                </el-menu-item>
                <el-menu-item index="schoolEducationClass">
                    <router-link class="nav-item" to="/school/education/class">班级管理</router-link>
                </el-menu-item>
                <el-menu-item index="schoolEducationStudent">
                    <router-link class="nav-item" to="/school/education/student">学生管理</router-link>
                </el-menu-item>
            </el-menu>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "SchoolEducationLayout",
        data() {
            return {
                schoolTab: '',
            }
        },
        created() {
            this.schoolTab = this.$route.name;
        },
    }
</script>

<style scoped lang="scss">
    .left-nav {
        .el-menu-item {
            padding: 0!important;
            height: 46px;
            line-height:46px;
            border-left: 2px solid transparent;
            .nav-item {
                padding: 0 20px;
                display: block;
                color: #333;
            }
            &.is-active {
                height:46px;
                line-height:46px;
                .nav-item {
                    color: #1E34E4;
                }
            }
            &.is-active:after{
                position: absolute;
                content: '';
                height: 14px;
                width: 3px;
                background: #1E34E4;
                top: 16px;
            }
            &.el-menu-item:focus, &.el-menu-item:hover {
                outline: 0;
                background-color: transparent;
            }

        }
    }

</style>